var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirroricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    id: "svg3755",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3757"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-1036.3622)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 16,
    id: "rect4482",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "none"
    },
    width: 16,
    x: 0,
    y: 1036.3622
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15,1037.3622 -7,1.5 0,11 7,1.5 z",
    id: "path4295-4",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3015"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 8,2.5 8,13.5 1,15 z",
    id: "path4295",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0,1036.3622)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4414",
    transform: "translate(16.25,1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -12,9 2,-2 -2,-2",
    id: "path4410",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0,1036.3622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -14,7 3.5,0",
    id: "path4412",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0,1036.3622)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3010",
    transform: "matrix(0.97629601,-0.21643961,0.21643961,0.97629601,-226.10453,27.374476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4414-4",
    transform: "matrix(-0.97629601,-0.21643961,-0.21643961,0.97629601,226.20936,23.134576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -12,9 2,-2 -2,-2",
    id: "path4410-8",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0,1036.3622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -14,7 3.5,0",
    id: "path4412-8",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(0,1036.3622)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirroricon);
export default __webpack_public_path__ + "static/media/mirror+icon.153c31f433724ff47e337641525f9ef9.svg";
export { ForwardRef as ReactComponent };